import React, { FunctionComponent } from "react";
import styled from "styled-components";
import theme from "../theme";
import { ReactComponent as HeaderIcon } from "../../assets/svg/header-icon.svg";

interface Props {
  icon?: boolean;
  color?: "default" | "alternate";
}

const Wrapper = styled.h2<Props>`
  margin: 0 0 ${theme.unit}px 0;
  font-size: ${theme.fonts.big.fontSize};
  line-height: ${theme.fonts.big.lineHeight};
  font-weight: ${theme.fonts.big.fontWeight};
  color: ${(props) =>
    props.color === "alternate" ? theme.colors.blue : theme.colors.black};
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;

  svg {
    margin-right: ${theme.unit * 0.5}px;
    vertical-align: middle;
    height: 12px;
  }
`;

const H2: FunctionComponent<Props> = ({ children, icon, ...rest }) => {
  return (
    <Wrapper {...rest}>
      {icon && <HeaderIcon />}
      {children}
    </Wrapper>
  );
};

export default H2;
